import { Service } from '../structure';
import { Auth } from '../Auth';
import { reaction } from 'mobx';
import { FreeMinerState } from '../FreeMinerState/FreeMinerState';

export default class FreeMinerConsumerService implements Service {
  constructor(
    private readonly _root: {
      readonly auth: Auth;
      readonly freeMinerState: FreeMinerState;
    },
  ) { }

  private _listenWhenConnected() {
    return reaction(
      () =>
        this._root.auth.state?.kind === 'Connected' && this._root.auth.state,
      (state, __, _) => {
        if (state) {
          this._root.freeMinerState.hasBacklightBeenShown().then((shown) => {
            if (!shown) {
              this._root.freeMinerState.setCanShowFreeMinerModal(true);
            } else {
              this._root.freeMinerState.setCanShowFreeMinerBacklight(false);
            }
          });
          _.dispose();
        }
      },
    );
  }

  subscribe() {
    return this._listenWhenConnected();
  }
}
